import axios from 'axios';

const BASE_URL = 'https://myhomeapi-jkao.onrender.com'; // Adjust base URL if needed
const IMAGE_URL = 'https://myhomeapi-jkao.onrender.com/uploads/';
//const BASE_URL = 'http://localhost:5000'; // local dvelopmen urls
//const IMAGE_URL = 'http://localhost:5000/uploads/';
// Create axios instance with timeout
const axiosInstance = axios.create({

  baseURL: BASE_URL,
  timeout: 5000, // 5 second timeout
});

// Add error interceptor to suppress console errors
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    // Silently fail without throwing
    return Promise.resolve({ data: [] });
  }
);

const config = {
    BASE_URL,
    IMAGE_URL,
    // login
      login: (data) => axiosInstance.post(`/login`, data).catch(() => ({ data: {} })),
    //banner
    createBanner: (data) => axiosInstance.post(`/banner`, data).catch(() => ({ data: {} })),
    getAllBanners: (data) => axiosInstance.get(`/banner`, data).catch(() => ({ data: [] })),
    getBannerByName: (data) => axiosInstance.get(`/getBannerByName?page=${data}`).catch(() => ({ data: [] })),
    getBannerById: (data) => axiosInstance.post(`/banner/edit`, data).catch(() => ({ data: {} })),
    bannerImageUpload: (data) => axiosInstance.post(`/banner/bannerImageUpload`, data, { headers: { 'Content-Type': 'multipart/form-data' } }).catch(() => ({ data: {} })),
    removeBanner: (data) => axiosInstance.post(`/banner/delete`, data).catch(() => ({ data: {} })),
    // users
    createUser: (data) => axiosInstance.post(`/users`, data).catch(() => ({ data: {} })),
    getAllUsers: (data) => axiosInstance.get(`/users`, data).catch(() => ({ data: [] })),
    getUserById: (data) => axiosInstance.post(`/users/edit`, data).catch(() => ({ data: {} })),
    userImageUpload: (data) => axiosInstance.post(`/users/userImageUpload`, data, { headers: { 'Content-Type': 'multipart/form-data' } }).catch(() => ({ data: {} })),
    removeUser: (data) => axiosInstance.post(`/users/delete`, data).catch(() => ({ data: {} })),
    //property routes
    createProperty: (data) => axiosInstance.post(`/property`, data).catch(() => ({ data: {} })),
    getAllProperty: (data) => axiosInstance.get(`/property?userId=${data.userId}&userType=${data.userType}`).catch(() => ({ data: [] })),
    getPropertyById: (data) => axiosInstance.post(`/property/edit`, data).catch(() => ({ data: {} })),
    removeProperty: (data) => axiosInstance.post(`/property/delete`, data).catch(() => ({ data: {} })),
    propertyImageUpload: (data) => axiosInstance.post(`/property/propertyImageUpload`, data, { headers: { 'Content-Type': 'multipart/form-data' } }).catch(() => ({ data: {} })),

    // Banners
    getBanners: (data) => axiosInstance.post(`/getBanners`, data).catch(() => ({ data: [] })),
    contactusFormData: () => axiosInstance.get(`/contactusFormData`).catch(() => ({ data: [] })),
    getFormById: (data) => axiosInstance.post(`/contactus/edit`, data).catch(() => ({ data: {} })),
    // webApis =>
    getAllProperties: () => axiosInstance.get(`/getAllProperties`).catch(() => ({ data: [] })),
    //contact us routes
    contactUs: (data) => axiosInstance.post(`/contactUs`, data, { headers: { "Content-Type": "application/json" } }).catch(() => ({ data: {} })),
    contactUsImageUpload: (data) => axiosInstance.post(`/contactus/contactUsImageUpload`, data, { headers: { 'Content-Type': 'multipart/form-data' } }).catch(() => ({ data: {} })),
};

export default config;
